<div class="blue">
    <app-navbar></app-navbar>
</div>
<div class="main">
    <p>HALL OF FAME COMING SOON!</p>
</div>
<app-footer></app-footer>